<template>
  <div
    class="p-1 border-right border-dark text-bold"
    style="width: 100%;background-color:rgb(204,255,179)"
  >
    {{ subtitle }}
  </div>
</template>
<script>
export default {
  props: ['subtitle'],
}
</script>
